import React, { useState } from 'react';
import { PencilIcon, XIcon, FileTextIcon, LinkIcon } from 'lucide-react';
type Section = 'secteurs' | 'ressources';
interface Zone {
  id: string;
  nomFr: string;
  nomAn: string;
}
interface Ressource {
  id: string;
  titreFr: string;
  titreAn: string;
  type: 'document' | 'lien';
  url: string;
}
const INITIAL_ZONES: Zone[] = [{
  id: '1',
  nomFr: 'Secteurs A-B-E',
  nomAn: 'A-B-E Sectors'
}, {
  id: '2',
  nomFr: 'Secteurs C-I-J-L-M-X-Y',
  nomAn: 'C-I-J-L-M-X-Y Sectors'
}, {
  id: '3',
  nomFr: 'Secteurs N-O-S',
  nomAn: 'N-O-S Sectors'
}, {
  id: '4',
  nomFr: 'Secteurs P-R-T-V',
  nomAn: 'P-R-T-V Sectors'
}];
const INITIAL_RESSOURCES: Ressource[] = [{
  id: '1',
  titreFr: 'Calendrier des collectes 2026',
  titreAn: '2026 Collection Calendar',
  type: 'document',
  url: 'https://www.brossard.ca/calendrier-collectes.pdf'
}, {
  id: '2',
  titreFr: 'Guide du tri des matières résiduelles',
  titreAn: 'Waste Sorting Guide',
  type: 'document',
  url: 'https://www.brossard.ca/guide-tri.pdf'
}, {
  id: '3',
  titreFr: 'Trouver mon secteur de collecte',
  titreAn: 'Find My Collection Sector',
  type: 'lien',
  url: 'https://images.app.goo.gl/PbPhBmsQyacfdbZu8'
}];
export function CollectesConfigurer() {
  const [activeSection, setActiveSection] = useState<Section>('secteurs');
  // ── Secteurs (Zones) ──────────────────────────────────────
  const [zones, setZones] = useState<Zone[]>(INITIAL_ZONES);
  const [editingZoneId, setEditingZoneId] = useState<string | null>(null);
  const [zoneForm, setZoneForm] = useState({
    nomFr: '',
    nomAn: ''
  });
  const [lienSecteurs, setLienSecteurs] = useState('https://images.app.goo.gl/PbPhBmsQyacfdbZu8');
  const handleEditZone = (zone: Zone) => {
    setEditingZoneId(zone.id);
    setZoneForm({
      nomFr: zone.nomFr,
      nomAn: zone.nomAn
    });
  };
  const handleSaveZone = (id: string) => {
    setZones(zones.map(z => z.id === id ? {
      ...z,
      ...zoneForm
    } : z));
    setEditingZoneId(null);
  };
  const handleDeleteZone = (id: string) => {
    setZones(zones.filter(z => z.id !== id));
  };
  const handleAddZone = () => {
    const newId = Math.random().toString(36).substr(2, 9);
    setZones([{
      id: newId,
      nomFr: '',
      nomAn: ''
    }, ...zones]);
    setEditingZoneId(newId);
    setZoneForm({
      nomFr: '',
      nomAn: ''
    });
  };
  // ── Ressources ────────────────────────────────────────────
  const [ressources, setRessources] = useState<Ressource[]>(INITIAL_RESSOURCES);
  const [editingResId, setEditingResId] = useState<string | null>(null);
  const [resForm, setResForm] = useState<{
    titreFr: string;
    titreAn: string;
    type: 'document' | 'lien';
    url: string;
  }>({
    titreFr: '',
    titreAn: '',
    type: 'document',
    url: ''
  });
  const handleEditRes = (res: Ressource) => {
    setEditingResId(res.id);
    setResForm({
      titreFr: res.titreFr,
      titreAn: res.titreAn,
      type: res.type,
      url: res.url
    });
  };
  const handleSaveRes = (id: string) => {
    setRessources(ressources.map(r => r.id === id ? {
      ...r,
      ...resForm
    } : r));
    setEditingResId(null);
  };
  const handleDeleteRes = (id: string) => {
    setRessources(ressources.filter(r => r.id !== id));
  };
  const handleAddRes = () => {
    const newId = Math.random().toString(36).substr(2, 9);
    setRessources([{
      id: newId,
      titreFr: '',
      titreAn: '',
      type: 'document',
      url: ''
    }, ...ressources]);
    setEditingResId(newId);
    setResForm({
      titreFr: '',
      titreAn: '',
      type: 'document',
      url: ''
    });
  };
  // ── Secteurs section render ───────────────────────────────
  const renderSecteurs = () => <div className="space-y-6" data-id="element-1395" data-mp="1gvwnewlkeat4">
      <div className="flex items-center justify-between" data-id="element-1396" data-mp="3doonta18zcux">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-1397" data-mp="3dq9h6wbtspr7">Secteurs</h3>
        <button onClick={handleAddZone} className="bg-[#4F46E5] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1398" data-mp="3imzy1lvgfpdo">
          Ajouter une zone
        </button>
      </div>

      <div className="space-y-4" data-id="element-1399" data-mp="17zcx21if5s1e">
        {zones.map(zone => <div key={zone.id} className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-id="element-1400" data-mp="1m075gk5gvt02">
            {editingZoneId === zone.id ? <div className="p-6 relative" data-id="element-1401" data-mp="1hyc7npmqvxr1">
                <button onClick={() => {
            if (!zone.nomFr && !zone.nomAn) handleDeleteZone(zone.id);else setEditingZoneId(null);
          }} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600" aria-label="Fermer" data-id="element-1402" data-mp="1hwhk03k39rj9">
                  <XIcon className="w-5 h-5" data-id="element-1403" data-mp="131usenbfpyz7" />
                </button>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1404" data-mp="yamlpz1horpq">
                  <div data-id="element-1405" data-mp="y9betqcqz3ue">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1406" data-mp="al0lr9dam8go">
                      Nom de la zone FR
                    </label>
                    <input type="text" value={zoneForm.nomFr} onChange={e => setZoneForm({
                ...zoneForm,
                nomFr: e.target.value
              })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1407" data-mp="6ixaakqmj3ve" />
                  </div>
                  <div data-id="element-1408" data-mp="3nljmsm4pxz3e">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1409" data-mp="3nl0618qt1gqy">
                      Nom de la zone AN
                    </label>
                    <input type="text" value={zoneForm.nomAn} onChange={e => setZoneForm({
                ...zoneForm,
                nomAn: e.target.value
              })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1410" data-mp="f45akecc6ymw" />
                  </div>
                </div>
                <div className="flex justify-end" data-id="element-1411" data-mp="2pwhmupnv51iu">
                  <button onClick={() => handleSaveZone(zone.id)} className="border border-[#4F46E5] text-[#4F46E5] px-4 py-1.5 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-1412" data-mp="2uwvy0gkrgrl3">
                    Sauvegarder
                  </button>
                </div>
              </div> : <div className="px-4 py-4 flex items-center justify-between" data-id="element-1413" data-mp="rolsi8ut80jo">
                <span className="text-sm text-slate-700" data-id="element-1414" data-mp="rmr3ojgf3oab">{zone.nomFr}</span>
                <div className="flex items-center gap-3" data-id="element-1415" data-mp="mopowaq0yb4n">
                  <button onClick={() => handleEditZone(zone)} className="text-slate-400 hover:text-slate-600" aria-label="Modifier" data-id="element-1416" data-mp="hq62yabfkzca">
                    <PencilIcon className="w-4 h-4" data-id="element-1417" data-mp="do1a3dst46qp" />
                  </button>
                  <button onClick={() => handleDeleteZone(zone.id)} className="text-slate-400 hover:text-slate-600" aria-label="Supprimer" data-id="element-1418" data-mp="8oy3vq13buh5">
                    <XIcon className="w-4 h-4" data-id="element-1419" data-mp="3shdep6f540w" />
                  </button>
                </div>
              </div>}
          </div>)}
      </div>

      <div className="mt-8" data-id="element-1420" data-mp="1y4xk1r34mk6a">
        <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1421" data-mp="1y5pbqqtlrxra">
          Lien vers les secteurs
        </label>
        <input type="text" value={lienSecteurs} onChange={e => setLienSecteurs(e.target.value)} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1422" data-mp="25nx13q347zmh" />
      </div>

      <div className="flex justify-end mt-8" data-id="element-1423" data-mp="2kdcp4yb9hqyh">
        <button className="bg-[#4F46E5] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1424" data-mp="2kcbgf0hpxgjx">
          Sauvegarder
        </button>
      </div>
    </div>;
  // ── Ressources section render ─────────────────────────────
  const renderRessources = () => <div className="space-y-6" data-id="element-1425" data-mp="1wlxjowo6utj0">
      <div className="flex items-center justify-between" data-id="element-1426" data-mp="1wpv1nez15f1b">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-1427" data-mp="21nd72vdu9c4k">Ressources</h3>
        <button onClick={handleAddRes} className="bg-[#4F46E5] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1428" data-mp="383grl2cprknw">
          Ajouter une ressource
        </button>
      </div>

      <p className="text-sm text-slate-500" data-id="element-1429" data-mp="21gf1v9wvsq6">
        Documents et liens utiles partagés aux citoyens (calendriers, guides de
        tri, page de recherche de secteur, etc.).
      </p>

      <div className="space-y-4" data-id="element-1430" data-mp="bqht3fwwc01i">
        {ressources.map(res => <div key={res.id} className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-id="element-1431" data-mp="bs1cvghrgt81">
            {editingResId === res.id ? <div className="p-6 relative" data-id="element-1432" data-mp="kqda41d4up9g">
                <button onClick={() => {
            if (!res.titreFr && !res.url) handleDeleteRes(res.id);else setEditingResId(null);
          }} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600" aria-label="Fermer" data-id="element-1433" data-mp="kp39b4ewb2z4">
                  <XIcon className="w-5 h-5" data-id="element-1434" data-mp="pq94d8w132bt" />
                </button>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1435" data-mp="pnwmswu6mtza">
                  <div data-id="element-1436" data-mp="2wgz3x4v3zll0">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1437" data-mp="2wijqa779ry7s">
                      Titre FR
                    </label>
                    <input type="text" value={resForm.titreFr} onChange={e => setResForm({
                ...resForm,
                titreFr: e.target.value
              })} placeholder="Titre de la ressource en Français" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1438" data-mp="16z1y6c7wb2xu" />
                  </div>
                  <div data-id="element-1439" data-mp="o8khx7491ztd">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1440" data-mp="o793mdd6h9o0">
                      Titre AN
                    </label>
                    <input type="text" value={resForm.titreAn} onChange={e => setResForm({
                ...resForm,
                titreAn: e.target.value
              })} placeholder="Titre de la ressource en Anglais" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1441" data-mp="eao05wgt46ma" />
                  </div>
                  <div data-id="element-1442" data-mp="a99tadpic5m2">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1443" data-mp="a9006h961ic5">
                      Type
                    </label>
                    <select value={resForm.type} onChange={e => setResForm({
                ...resForm,
                type: e.target.value as 'document' | 'lien'
              })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1444" data-mp="f1ayxgs66y34">
                      <option value="document" data-id="element-1445" data-mp="xykj505bkflf">Document</option>
                      <option value="lien" data-id="element-1446" data-mp="xwro6i42jjt9">Lien</option>
                    </select>
                  </div>
                  <div data-id="element-1447" data-mp="j3o7se27rc44">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1448" data-mp="o0el4tmmvtlu">
                      URL
                    </label>
                    <input type="text" value={resForm.url} onChange={e => setResForm({
                ...resForm,
                url: e.target.value
              })} placeholder="https://..." className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1449" data-mp="33r14act8ylj8" />
                  </div>
                </div>
                <div className="flex justify-end" data-id="element-1450" data-mp="1zsxfgpseyore">
                  <button onClick={() => handleSaveRes(res.id)} className="border border-[#4F46E5] text-[#4F46E5] px-4 py-1.5 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-1451" data-mp="1zrm7sevukwv0">
                    Sauvegarder
                  </button>
                </div>
              </div> : <div className="px-4 py-4 flex items-center justify-between" data-id="element-1452" data-mp="131ldy1gmfq6u">
                <div className="flex items-center gap-3 min-w-0" data-id="element-1453" data-mp="1gwnrnarpmju7">
                  <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center flex-shrink-0" data-id="element-1454" data-mp="1c3uq0vrjfrmc">
                    {res.type === 'document' ? <FileTextIcon className="w-4 h-4" data-id="element-1455" data-mp="ocp6o6me2h7a" /> : <LinkIcon className="w-4 h-4" data-id="element-1456" data-mp="kdq771jffcn8" />}
                  </div>
                  <div className="min-w-0" data-id="element-1457" data-mp="2jhydbr3uzv2t">
                    <p className="text-sm font-medium text-slate-700 truncate" data-id="element-1458" data-mp="2jgwxl9bweker">
                      {res.titreFr}
                    </p>
                    <p className="text-xs text-slate-400 truncate" data-id="element-1459" data-mp="2oeor27s6yel2">{res.url}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 ml-4" data-id="element-1460" data-mp="2y6l18h7jxv5n">
                  <button onClick={() => handleEditRes(res)} className="text-slate-400 hover:text-slate-600" aria-label="Modifier" data-id="element-1461" data-mp="2y8p2ere2gg28">
                    <PencilIcon className="w-4 h-4" data-id="element-1462" data-mp="25hnn8qadikip" />
                  </button>
                  <button onClick={() => handleDeleteRes(res.id)} className="text-slate-400 hover:text-slate-600" aria-label="Supprimer" data-id="element-1463" data-mp="2aha0v0u462s1">
                    <XIcon className="w-4 h-4" data-id="element-1464" data-mp="2fheiiu6rd3ju" />
                  </button>
                </div>
              </div>}
          </div>)}
      </div>

      <div className="flex justify-end mt-8" data-id="element-1465" data-mp="3lyrsx32c1dyq">
        <button className="bg-[#4F46E5] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1466" data-mp="3quql71qs7g4f">
          Sauvegarder
        </button>
      </div>
    </div>;
  return <div className="flex gap-6" data-id="element-1467" data-mp="1a8tr032lf4f3">
      {/* Section Switcher */}
      <div className="w-48 flex-shrink-0" data-id="element-1468" data-mp="15iddyk2opkt9">
        <div className="bg-white rounded-xl border border-slate-200 p-2 space-y-1 sticky top-4" data-id="element-1469" data-mp="15hbqth8e97v6">
          <button onClick={() => setActiveSection('secteurs')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'secteurs' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1470" data-mp="10i8x2sxv6o2i">
            Secteurs
          </button>
          <button onClick={() => setActiveSection('ressources')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'ressources' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1471" data-mp="mk12groavyui">
            Ressources
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 bg-white rounded-xl border border-slate-200 p-8 min-w-0" data-id="element-1472" data-mp="19krkoq37co2l">
        {activeSection === 'secteurs' ? renderSecteurs() : renderRessources()}
      </div>
    </div>;
}